import React from 'react';
import {useQuery} from "react-query";
import ngage from "services/ngage";
import StatList from "components/StatList";
import StatBox from "components/StatBox";
import Page from "components/Page";
import {useOperator} from "context/OperatorContext";
import Card from "components/Card";
import MessageSchedule from "./MessageSchedule";
import VisitorsDensityMap from "components/Maps/VisitorsDensityMap";
import {IdentificationIcon, ShoppingCartIcon, SparklesIcon, TicketIcon, TruckIcon} from "@heroicons/react/outline";
import {useAuth} from "context/AuthContext";
import {VisitorsLocationMap} from "../../components/Maps/VisitorsLocationMap";
import {useSearchParams} from "react-router-dom";
import {useIsCurrentOperatorAllowed} from "../../hooks/useIsCurrentOperatorAllowed";
import {DateTime} from "luxon";
import Button from "../../components/Button";

// Helpers ----

// Calculate the change rate between two values as a percentage
function changeRate(firstValue: number, secondValue: number): string {
  const delta = firstValue - secondValue
  const change = delta / (secondValue || 1)

  return Math.round(change * 100) + '%'
}

// Component ----

function Dashboard() {
  const {termFor, operator} = useOperator();
  const auth = useAuth();

  const [searchParams] = useSearchParams();
  const hasRealtimeParam = useIsCurrentOperatorAllowed() || searchParams.get('realtime') === 'enabled';

  // Fetch insights summary data for stat boxes
  const {data: insights, isLoading: loadingInsights} = useQuery(
    ['insights.summary'],
    ngage.insights.summary,
    {enabled: auth.can('insights:read')}
  );

  // Fetch scheduled messages
  const {data: scheduledMessages, isLoading: loadingScheduledMessages} = useQuery(
    ['messages.scheduled'],
    () => ngage.messages.filtered({scheduled: true}),
    {enabled: auth.can('messages:read')}
  );

  return (
    <Page
      title={`Welcome back${auth.user?.first_name ? `, ${auth.user.first_name}` : ''}`}
      subTitle={operator?.name ? `Here’s what’s happening across ${operator.name}` : ''}
    >
      {/*<div className="flex flex-col gap-10 bg-white p-6">*/}
      {/*  <div className='flex flex-col gap-4'>*/}
      {/*    <h2>Primary</h2>*/}
      {/*    <div className="flex flex-col gap-x-8 gap-y-3">*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button size={Button.sizes.TINY}>Save</Button>*/}
      {/*        <Button size={Button.sizes.TINY} showSpinner={true}>Save</Button>*/}
      {/*        <Button size={Button.sizes.TINY} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button size={Button.sizes.X_SMALL}>Save</Button>*/}
      {/*        <Button size={Button.sizes.X_SMALL} showSpinner={true}>Save</Button>*/}
      {/*        <Button size={Button.sizes.X_SMALL} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button size={Button.sizes.SMALL}>Save</Button>*/}
      {/*        <Button size={Button.sizes.SMALL} showSpinner={true}>Save</Button>*/}
      {/*        <Button size={Button.sizes.SMALL} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button size={Button.sizes.MEDIUM}>Save</Button>*/}
      {/*        <Button size={Button.sizes.MEDIUM} showSpinner={true}>Save</Button>*/}
      {/*        <Button size={Button.sizes.MEDIUM} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button size={Button.sizes.LARGE}>Save</Button>*/}
      {/*        <Button size={Button.sizes.LARGE} showSpinner={true}>Save</Button>*/}
      {/*        <Button size={Button.sizes.LARGE} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button size={Button.sizes.X_LARGE}>Save</Button>*/}
      {/*        <Button size={Button.sizes.X_LARGE} showSpinner={true}>Save</Button>*/}
      {/*        <Button size={Button.sizes.X_LARGE} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}

      {/*  <div className='flex flex-col gap-4'>*/}
      {/*    <h2>Secondary</h2>*/}
      {/*    <div className="flex flex-col gap-x-8 gap-y-3">*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.SECONDARY} size={Button.sizes.TINY}>Save</Button>*/}
      {/*        <Button color={Button.colors.SECONDARY} size={Button.sizes.TINY} showSpinner={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.SECONDARY} size={Button.sizes.TINY} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.SECONDARY} size={Button.sizes.X_SMALL}>Save</Button>*/}
      {/*        <Button color={Button.colors.SECONDARY} size={Button.sizes.X_SMALL} showSpinner={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.SECONDARY} size={Button.sizes.X_SMALL} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.SECONDARY} size={Button.sizes.SMALL}>Save</Button>*/}
      {/*        <Button color={Button.colors.SECONDARY} size={Button.sizes.SMALL} showSpinner={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.SECONDARY} size={Button.sizes.SMALL} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.SECONDARY} size={Button.sizes.MEDIUM}>Save</Button>*/}
      {/*        <Button color={Button.colors.SECONDARY} size={Button.sizes.MEDIUM} showSpinner={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.SECONDARY} size={Button.sizes.MEDIUM} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.SECONDARY} size={Button.sizes.LARGE}>Save</Button>*/}
      {/*        <Button color={Button.colors.SECONDARY} size={Button.sizes.LARGE} showSpinner={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.SECONDARY} size={Button.sizes.LARGE} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.SECONDARY} size={Button.sizes.X_LARGE}>Save</Button>*/}
      {/*        <Button color={Button.colors.SECONDARY} size={Button.sizes.X_LARGE} showSpinner={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.SECONDARY} size={Button.sizes.X_LARGE} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}

      {/*  <div className='flex flex-col gap-4'>*/}
      {/*    <h2>Red</h2>*/}
      {/*    <div className="flex flex-col gap-x-8 gap-y-3">*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.TINY}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.TINY} showSpinner={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.TINY} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.X_SMALL}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.X_SMALL} showSpinner={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.X_SMALL} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.SMALL}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.SMALL} showSpinner={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.SMALL} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.MEDIUM}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.MEDIUM} showSpinner={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.MEDIUM} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.LARGE}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.LARGE} showSpinner={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.LARGE} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.X_LARGE}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.X_LARGE} showSpinner={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.X_LARGE} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}

      {/*  <div className='flex flex-col gap-4'>*/}
      {/*    <h2>White</h2>*/}
      {/*    <div className="flex flex-col gap-x-8 gap-y-3">*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.WHITE} size={Button.sizes.TINY}>Save</Button>*/}
      {/*        <Button color={Button.colors.WHITE} size={Button.sizes.TINY} showSpinner={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.WHITE} size={Button.sizes.TINY} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.WHITE} size={Button.sizes.X_SMALL}>Save</Button>*/}
      {/*        <Button color={Button.colors.WHITE} size={Button.sizes.X_SMALL} showSpinner={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.WHITE} size={Button.sizes.X_SMALL} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.WHITE} size={Button.sizes.SMALL}>Save</Button>*/}
      {/*        <Button color={Button.colors.WHITE} size={Button.sizes.SMALL} showSpinner={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.WHITE} size={Button.sizes.SMALL} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.WHITE} size={Button.sizes.MEDIUM}>Save</Button>*/}
      {/*        <Button color={Button.colors.WHITE} size={Button.sizes.MEDIUM} showSpinner={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.WHITE} size={Button.sizes.MEDIUM} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.WHITE} size={Button.sizes.LARGE}>Save</Button>*/}
      {/*        <Button color={Button.colors.WHITE} size={Button.sizes.LARGE} showSpinner={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.WHITE} size={Button.sizes.LARGE} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.WHITE} size={Button.sizes.X_LARGE}>Save</Button>*/}
      {/*        <Button color={Button.colors.WHITE} size={Button.sizes.X_LARGE} showSpinner={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.WHITE} size={Button.sizes.X_LARGE} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}

      {/*  <div className='flex flex-col gap-4'>*/}
      {/*    <h2>Disabled</h2>*/}
      {/*    <div className="flex flex-col gap-x-8 gap-y-3">*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.TINY} disabled={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.TINY} showSpinner={true} disabled={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.TINY} disabled={true} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.X_SMALL} disabled={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.X_SMALL} showSpinner={true} disabled={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.X_SMALL} disabled={true} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.SMALL} disabled={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.SMALL} showSpinner={true} disabled={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.SMALL} disabled={true} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.MEDIUM} disabled={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.MEDIUM} showSpinner={true} disabled={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.MEDIUM} disabled={true} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.LARGE} disabled={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.LARGE} showSpinner={true} disabled={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.LARGE} disabled={true} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*      <div className="flex gap-2.5 items-center">*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.X_LARGE} disabled={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.X_LARGE} showSpinner={true} disabled={true}>Save</Button>*/}
      {/*        <Button color={Button.colors.RED} size={Button.sizes.X_LARGE} disabled={true} icon={ShoppingCartIcon}>Save</Button>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">

        {/* Stats */}
        <div className="lg:col-span-2 space-y-6">

          {/* Today */}
          {auth.can('insights:read') &&
            <div>
              <h3 className="mb-2 text-lg leading-6 font-medium text-gray-900">Today</h3>

              <StatList>
                <StatBox
                  name={`Current ${termFor('Visits')}`}
                  icon={TruckIcon}
                  stat={insights?.engagement.current_visits.toLocaleString()}
                  isLoading={loadingInsights}
                  tooltip={`The number of ${termFor('visits')} currently taking place across all ${termFor('sites')} by registered app users.`}
                />

                <StatBox
                  name={`Valid ${termFor('Tickets')}`}
                  icon={TicketIcon}
                  stat={insights?.engagement.valid_tickets.toLocaleString()}
                  isLoading={loadingInsights}
                  tooltip={`The number of ${termFor('tickets')} valid for use today across all ${termFor('sites')}.`}
                />

                <StatBox
                  name={`Valid ${termFor('Memberships')}`}
                  icon={IdentificationIcon}
                  stat={insights?.engagement.valid_memberships.toLocaleString()}
                  isLoading={loadingInsights}
                  tooltip={`The number of ${termFor('memberships')} valid for use today across all ${termFor('sites')}.`}
                />
              </StatList>
            </div>
          }

          {/* Recent Interactions */}
          {auth.can('insights:read') &&
            <div>
              <h3 className="mb-2 text-lg leading-6 font-medium text-gray-900">Recent Interactions</h3>

              <StatList>
                <StatBox
                  name="Last 24 Hours"
                  icon={SparklesIcon}
                  stat={insights?.engagement.interactions.current_24_hours.toLocaleString()}
                  change={insights ? changeRate(insights.engagement.interactions.current_24_hours, insights.engagement.interactions.previous_24_hours) : 0}
                  isLoading={loadingInsights}
                  tooltip={"The number of interactions recorded across all sites by your audience in the last 24 hours."}
                />

                <StatBox
                  name="Last 7 Days"
                  icon={SparklesIcon}
                  stat={insights?.engagement.interactions.current_7_days.toLocaleString()}
                  change={insights ? changeRate(insights.engagement.interactions.current_7_days, insights.engagement.interactions.previous_7_days) : 0}
                  isLoading={loadingInsights}
                  tooltip={"The number of interactions recorded across all sites by registered app users in the last 7 days."}
                />

                <StatBox
                  name="Last 30 Days"
                  icon={SparklesIcon}
                  stat={insights?.engagement.interactions.current_30_days.toLocaleString()}
                  change={insights ? changeRate(insights.engagement.interactions.current_30_days, insights.engagement.interactions.previous_30_days) : 0}
                  isLoading={loadingInsights}
                  tooltip={"The number of interactions recorded across all sites by registered app users in the last 30 days."}
                />
              </StatList>
            </div>
          }

          {/* Interaction Heatmap */}
          <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900">Visitor Density</h3>
            <p className="mt-1 text-sm text-gray-500">Last 24 hours</p>

            <div className="mt-2 overflow-hidden shadow sm:rounded-lg">
              <VisitorsDensityMap
                height={"42rem"}
                showSiteSelector
                since={DateTime.now().minus({hours: 24})}
                until={DateTime.now()}
              />
            </div>
          </div>

          {/* Realtime Heatmap */}
          {hasRealtimeParam &&
            <div>
              <h3 className="text-lg leading-6 font-medium text-gray-900">Visitor Location</h3>

              <div className="mt-2 overflow-hidden shadow sm:rounded-lg">
                <VisitorsLocationMap height={"42rem"} showSiteSelector />
              </div>
            </div>
          }
        </div>

        {/* System Info */}
        <div className="lg:mt-8 space-y-8">

          {/* Message Schedule */}
          {auth.can('messages:read') &&
            <Card heading={"Message Schedule"} isLoading={loadingScheduledMessages}>
              {!!scheduledMessages && <MessageSchedule messages={scheduledMessages?.data ?? []}/>}
            </Card>
          }
        </div>
      </div>
    </Page>
  );
}

// Export ----

export default Dashboard;